import * as React from "react";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({
  theme = "system",
  toastOptions,
  ...props
}: ToasterProps) => (
  <Sonner
    theme={theme}
    className="toaster group"
    toastOptions={{
      ...toastOptions,
      classNames: {
        toast:
          "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        actionButton:
          "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton:
          "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        ...toastOptions?.classNames,
      },
    }}
    {...props}
  />
);

// eslint-disable-next-line react-refresh/only-export-components
export { Toaster, toast };
